import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { isUndefined } from 'lodash-es';
export var EventManager = function () {
  function EventManager() {
    _classCallCheck(this, EventManager);
    _defineProperty(this, "listeners", new Map());
    _defineProperty(this, "queue", []);
    _defineProperty(this, "isHolding", true);
  }
  _createClass(EventManager, [{
    key: "addToQueue",
    value: function addToQueue(event, params) {
      this.queue.push({
        action: event,
        params: params
      });
    }
  }, {
    key: "start",
    value: function start() {
      var _this = this;
      this.isHolding = false;
      this.queue.forEach(function (_ref) {
        var action = _ref.action,
          params = _ref.params;
        _this.emit.apply(_this, [action].concat(_toConsumableArray(params)));
      });
      this.queue = [];
    }
  }, {
    key: "stop",
    value: function stop() {
      this.isHolding = true;
    }
  }, {
    key: "on",
    value: function on(eventType, callback) {
      if (!this.listeners.has(eventType)) {
        this.listeners.set(eventType, []);
      }
      var events = this.listeners.get(eventType);
      if (events) {
        events.push(callback);
      }
      return this;
    }
  }, {
    key: "off",
    value: function off(event, callback) {
      var listeners = this.listeners.get(event);
      if (isUndefined(listeners)) return this;
      for (var i = 0, l = listeners.length; i < l; i++) {
        if (listeners[i] === callback) {
          listeners.splice(i, 1);
          return this;
        }
      }
      return this;
    }
  }, {
    key: "emit",
    value: function emit(event) {
      for (var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        params[_key - 1] = arguments[_key];
      }
      var events = this.listeners.get(event);
      if (this.isHolding) {
        this.addToQueue(event, params);
      } else if (events) {
        events.forEach(function (callback) {
          return setTimeout(function () {
            callback.apply(void 0, params);
          }, 0);
        });
      }
    }
  }]);
  return EventManager;
}();